import script from "./SeguradosRepository.vue?vue&type=script&lang=js"
export * from "./SeguradosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__